import i18n from "i18n";

export const toUserMessage = (error: any): string => {
  const isNetworkError =
    !error?.response &&
    (error?.code === 'ERR_NETWORK' ||
      error?.message?.includes('Network Error') ||
      error?.message?.includes('ERR_INTERNET_DISCONNECTED') ||
      !!error?.request);

  if (isNetworkError) {
    return i18n.t('common.networkError');
  }

  const isDbError = 
    error?.response?.data?.errorCode === 9
    error?.response?.data?.errorCode === 'DATABASE_UNAVAILABLE' || 
    (error?.response?.status === 500 && !error?.response?.data?.userMessage);

  if (isDbError) {
    return i18n.t('common.databaseUnavailable');
  }

  return (
    error?.response?.data?.userMessage ||
    error?.response?.data?.Message ||
    error?.response?.data?.message ||
    i18n.t('common.internalServerError')
  );
};